import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import Toast from '@components/Toast';
// 启用 duration 插件
dayjs.extend(duration);

interface VoteOption {
  id: string;
  label: string;
  value: string;
  votes?: number; // 票数
  percentage?: number; // 百分比
}

interface PCVoteListProps {
  app?: AppStore;
  site?: SiteStore;
  user?: UserAction;
  votesData: any
  threadData?: any;   // 帖子数据
//   question: string;
//   options: VoteOption[];
//   mode?: 'single' | 'multiple';
  onSubmit?: (selectedIds: string) => void;  // 改为字符串类型
  initialSelected?: string[];
  submitButtonText?: string;
  hasVoted?: boolean; // 是否已投票
  totalVotes?: number; // 总票数
  endAt?: any // 截止时间
  onVoteChange?: (selected: string[]) => void; // 选择变化回调
}

interface PCVoteListState {
  selectedOptions: string[];
  countdown: any
    hasExpired: any
    localVoted: boolean
}

@inject('app', 'site', 'user')
@observer
class PCVoteList extends React.Component<PCVoteListProps, PCVoteListState> {
    constructor(props: PCVoteListProps) {
        super(props);
        this.state = {
            selectedOptions: this.getInitialSelected(),
            countdown: this.getCountdown(),
            hasExpired: false,
            localVoted: false,
        };
    }
    private timer: NodeJS.Timeout | null = null;
    private hasLoggedExpired = false; // 防止重复打印
    componentDidMount() {
        this.startTimer();
    }

    componentWillUnmount() {
        this.stopTimer();
    }

    componentDidUpdate(prevProps: PCVoteListProps) {
        const prevVoteId = prevProps.votesData?.[0]?.id;
        const currentVoteId = this.props.votesData?.[0]?.id;
        if (prevVoteId !== currentVoteId || prevProps.hasVoted !== this.props.hasVoted) {
            this.stopTimer();
            this.setState({
                selectedOptions: this.getInitialSelected(),
                countdown: this.getCountdown(),
                localVoted: false,
            }, () => {
                this.startTimer();
            });
        }
    }
    /**
     * 倒计时方法 - 返回天、时、分
     */
    getCountdown = (endTime?: string | Date) => {
        const voteEnd = endTime || this.props.votesData?.[0]?.expiredAt || this.props.endAt;
        if (!voteEnd) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                isExpired: true
            };
        }

        const end = dayjs(voteEnd);
        const now = dayjs();
        const diff = end.diff(now);
        
        if (diff <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                isExpired: true
            };
        }
        
        const durationObj = dayjs.duration(diff);
        
        return {
            days: Math.floor(durationObj.asDays()),
            hours: durationObj.hours(),
            minutes: durationObj.minutes(),
            isExpired: false
        };
    }

    startTimer = () => {
        this.stopTimer();
        this.timer = setInterval(() => {
            const newCountdown = this.getCountdown();
            const justExpired = newCountdown.isExpired && !this.state.countdown.isExpired;
            this.setState({ countdown: newCountdown, hasExpired: justExpired });
            if (newCountdown.isExpired) {
                this.stopTimer();
            }
        }, 1000);
    }

    stopTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    getInitialSelected = () => {
        const options = this.props.votesData?.[0]?.options || [];
        const votedIds = options.filter((o: any) => o.isVoted).map((o: any) => String(o.id));
        if (votedIds.length > 0) return votedIds;
        return this.props.initialSelected || [];
    }

    /**
     * 更新倒计时状态
     */
    // updateCountdown = () => {
    //     const { endAt } = this.props;
    //     const prevCountdown = this.state.countdown; // 保存之前的状态
    //     const newCountdown = this.getCountdown(endAt);
        
    //     // 检查是否刚刚过期
    //     const justExpired = newCountdown.isExpired && !prevCountdown.isExpired;
        
    //     // console.log('更新倒计时状态:', {
    //     //     previous: prevCountdown,
    //     //     current: newCountdown,
    //     //     justExpired: justExpired
    //     // });
        
    //     this.setState({ 
    //         countdown: newCountdown,
    //         hasExpired: justExpired // 设置过期状态
    //     });
        
    //     // 如果刚刚过期，打印 console
    //     if (justExpired && !this.hasLoggedExpired) {
    //         console.log('🔔 投票活动已结束');
    //         this.hasLoggedExpired = true;
    //     }
        
    //     return newCountdown.isExpired;
    // }

    // /**
    //  * 启动倒计时定时器
    //  */
    // startTimer = () => {
    //     this.timer = setInterval(() => {
    //         const isExpired = this.updateCountdown();
    //         if (isExpired && this.timer) {
    //             clearInterval(this.timer);
    //             this.timer = null;
    //             console.log('⏰ 定时器已停止');
    //         }
    //     }, 1000); // 每秒更新一次
    // }

    // /**
    //  * 停止倒计时定时器
    //  */
    // stopTimer = () => {
    //     if (this.timer) {
    //         clearInterval(this.timer);
    //         this.timer = null;
    //         console.log('⏰ 定时器已清理');
    //     }
    // }

    // /**
    //  * 格式化倒计时显示
    //  */
    // formatCountdown = (countdown: { days: number; hours: number; minutes: number; isExpired: boolean }) => {
    //     const { days, hours, minutes, isExpired } = countdown;
        
    //     if (isExpired) {
    //         return '已结束';
    //     }
        
    //     const parts = [];
    //     if (days > 0) parts.push(`${days}天`);
    //     if (hours > 0 || days > 0) parts.push(`${hours}时`);
    //     parts.push(`${minutes}分`);
        
    //     return parts.join('') || '0分';
    // }
    
    // 处理选项选择
    handleOptionSelect = (optionId: string) => {
        const { selectedOptions, countdown, localVoted } = this.state;
        const { onVoteChange, votesData, hasVoted } = this.props;
        const hasVotedNow = hasVoted || localVoted;
        if (hasVotedNow || countdown.isExpired) return; // 已投票或过期后不可再选择
        let newSelected: string[];
        
        // 修改后
        if (votesData?.[0]?.choiceType === 1) {
            newSelected = selectedOptions.includes(optionId) 
                ? []  // 如果已选中，取消选择
                : [optionId];  // 如果未选中，选中
        } else {
            // 多选
            newSelected = this.state.selectedOptions.includes(optionId) 
                ? this.state.selectedOptions.filter(id => id !== optionId)
                : [...this.state.selectedOptions, optionId];
        }
        
        this.setState({ selectedOptions: newSelected });
        onVoteChange?.(newSelected);
    };

    // 处理提交投票
    handleSubmit = () => {
        const { selectedOptions, countdown, localVoted } = this.state;
        const { onSubmit, hasVoted } = this.props;
        const hasVotedNow = hasVoted || localVoted;

        if (countdown.isExpired) {
            Toast.info({ content: '投票已结束' });
            return;
        }

        if (hasVotedNow) {
            Toast.info({ content: '已投过票' });
            return;
        }
        
        if (selectedOptions.length === 0) {
            // 如果没有选中，就提示请选择选项
            Toast.info({content: '请选择选项'})
            return;
        }
        
        // this.setState({ hasVoted: true });
        if(onSubmit) {
            const selectedIds = selectedOptions.join(',');
            onSubmit(selectedIds);
        }
        this.setState({ localVoted: true });
        
    };

    // 重新投票
    // handleRevote = () => {
    //     this.setState({ 
    //     isVoted: false, 
    //     selectedOptions: [] 
    //     });
    // };
    // 获取百分比
        getPercentage = (value, total, decimals = 0) => {
                if (total === 0 || isNaN(value) || isNaN(total)) {
                    return '0%';
                }
                const percentage = (value / total) * 100;
                return `${percentage.toFixed(decimals)}%`;
    }

    // 检查选项是否被选中
    isOptionSelected = (optionId: string) => {
        return this.state.selectedOptions.includes(optionId);
    };

    render() {
        const { selectedOptions, countdown, localVoted } = this.state;
        let { threadData, votesData, hasVoted } = this.props;
        const vote = votesData?.[0];
        if (!vote) { return null; }
        const options = vote.options || [];
        const totalVotes = vote.userCount || options.reduce((sum: number, item: any) => sum + (item.voteCount || 0), 0);
        const { days, hours, minutes } = countdown;
        const hasVotedNow = hasVoted || localVoted;
        const disabled = hasVotedNow || countdown.isExpired;
        console.log(disabled, hasVoted, localVoted, '是否可以投票')
        return (
        <div className={styles.voteListBox}>
            {/* 问题区域 */}
            <div className={styles.questionSection}>
                <h3 className={styles.questionText}>{vote?.title}</h3>
            </div>
            {/* 选项区域 */}
            <div className={classNames(styles.optionsSection, hasVoted ? styles.isVotedSection : '')}>
                {options.map(option => {
                    const isSelected = this.isOptionSelected(String(option.id));
                    // console.log(`选项 ${option.id} 是否被选中:`, isSelected);
                    
                    return (
                        <div
                            key={option.id}
                            className={classNames(
                            styles.optionItem,
                            isSelected ? styles.selected : '',
                            option.isVoted ? styles.selected : ''
                            )}
                            onClick={() => this.handleOptionSelect(String(option.id))}
                        >
                            <div className={styles.optionContent}>
                            {/* 选项标签和文本 */}
                            <div className={styles.optionInfo}>
                                <span className={styles.optionText}>{option.content}</span>
                            </div>
                            
                            {/* 右侧内容 */}
                            <div className={styles.optionRight}>
                                {/* 投票后显示票数 */}
                                {hasVotedNow ? (
                                <div className={styles.voteResult}>
                                    <span className={styles.voteCount}>{option.voteCount || 0}票</span>
                                    {isSelected && (
                                    <img 
                                        src={`${BASE_IMG_URL}/common/checked.png`} 
                                        alt="已选" 
                                        className={styles.voteChecked}
                                    />
                                    )}
                                </div>
                                ) : (
                                // 投票前显示选中指示器
                                isSelected && (
                                    <div className={styles.selectedIndicator}>
                                    <img 
                                        src={`${BASE_IMG_URL}/common/checked.png`} 
                                        alt="选中"
                                        className={styles.checkIcon}
                                    />
                                    </div>
                                )
                                )}
                            </div>
                            </div>
                            
                            {/* 进度条（已投票状态显示） */}
                            {hasVotedNow && (
                            <div className={styles.progressBar}>
                                <div 
                                className={`${styles.progressFill} ${
                                    isSelected ? styles.selectedProgress : ''
                                }`}
                                style={{ width: this.getPercentage(option.voteCount, totalVotes) }}
                                ></div>
                            </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* 操作按钮区域 */}
            <div className={styles.actionSection}>
                <button 
                    className={classNames(styles.submitButton, (disabled) ? styles.disabled : '')}
                    onClick={() => window.globalEnsureLogin(() => {
                        (!disabled && threadData?.isApproved == 1) ? this.handleSubmit() : undefined
                    })}
                >
                {countdown.isExpired ? '已结束' : hasVotedNow ? '已投票' : '投票'}
                </button>
            </div>
            {/* 投票信息 */}
            <div className={styles.voteStatus}>
                <span className={styles.totalVotes}>已有{totalVotes}人参与</span>
                <div className={styles.voteEndAt}>{countdown.isExpired ? '' : '距结束：'}{countdown.isExpired ? '已结束' : (<><span>{days}</span>天<span>{hours}</span>小时<span>{minutes}</span>分</>)}</div>
            </div>
        </div>
        );
    }
}

export default PCVoteList;